export const OVERLAY_PATH = 'https://web-native-display-campaign.clevertap.com/production/lib-overlay/overlay.js'
export const CSS_PATH = 'https://web-native-display-campaign.clevertap.com/production/lib-overlay/style.css'
export const WVE_CLASS = {
  FLICKER_SHOW: 'wve-anti-flicker-show',
  FLICKER_HIDE: 'wve-anti-flicker-hide',
  FLICKER_ID: 'wve-flicker-style'
}
